import React, { createContext, useContext } from 'react'
import useSeti from '../CustomHooks/useSeti'
import BootstrapDataContext from '../../context/BootstrapDataContext'

export const SetiRedesignContext = createContext({
  isHPTextVariant: false,
  isHotelsTextVariant: false,
  isHPLPMblTabIcons: false,
  isHPCornerShadowColorRedesign: false,
  isHotelsCornerShadClrVariant: false
})

const pagesWithRefreshTabs = ['home', 'hotels', 'flights', 'packages']

export const SetiRedesignProvider = ({
  children
}: {
  children: React.ReactNode
}) => {
  const { key } = useContext(BootstrapDataContext)

  const redesignSetis = {
    isHPTextVariant:
      useSeti('HP_TEXT_STYLES', key === 'home') === 'VARIANT' && key === 'home',
    isHotelsTextVariant:
      useSeti('HTL_LP_TEXT_STYLES', key === 'hotels') === 'VARIANT' &&
      key === 'hotels',
    isHPLPMblTabIcons:
      useSeti('HP_LP_MBL_TAB_ICONS', pagesWithRefreshTabs.includes(key)) ===
        'VARIANT' && pagesWithRefreshTabs.includes(key),
    isHPCornerShadowColorRedesign:
      useSeti('HP_CORNERS_SHADOWS_COLORS', key === 'home') === 'VARIANT' &&
      key === 'home',
    isHotelsCornerShadClrVariant:
      useSeti('HTL_LP_CORNERS_SHADOWS_COLORS', key === 'hotels') ===
        'VARIANT' && key === 'hotels'
  }
  return (
    <SetiRedesignContext.Provider value={redesignSetis}>
      {children}
    </SetiRedesignContext.Provider>
  )
}
